import { useRef } from 'react'
import { View } from 'react-native'
import styled from 'styled-components'
import { useMediaIs } from '@flix/common/style/media'
import { cursorPointer } from '../../../style/webStyles'
import { BaseCarousel } from '../BaseCarousel/BaseCarousel'
import { ChevronArrowLeft, ChevronArrowRight } from '../FadingArrowCarousel/ChevronArrow'

const Container = styled(View)`
  flex-direction: row;
`

const CarouselArea = styled(View)`
  flex: 1 1 auto;
`

const ArrowArea = styled(View)`
  flex: 0 0 ${(props) => props.theme.spacing.larger}px;
  padding: 0 ${(props) => props.theme.spacing.medium}px;
  margin: 0 ${(props) => props.theme.spacing.sm}px;
  justify-content: center;
  align-items: center;
  ${cursorPointer};
`

export const ArrowsOutsideCarousel = ({
  style,
  onLayout,
  showPrev = true,
  showNext = true,
  arrowScale,
  arrowColor,
  ...props
}) => {
  const isLarge = useMediaIs('lg')
  const slider = useRef()
  const slidePrev = () => slider.current.slidePrev()
  const slideNext = () => slider.current.slideNext()

  return (
    <Container style={style}>
      {showPrev && (
        <ArrowArea>
          <ChevronArrowLeft
            gradientOpacity={0}
            onPress={slidePrev}
            color={arrowColor}
            scale={arrowScale ?? (isLarge ? 2 : 1.5)}
          />
        </ArrowArea>
      )}

      <CarouselArea onLayout={onLayout}>
        <BaseCarousel {...props} ref={slider} />
      </CarouselArea>

      {showNext && (
        <ArrowArea>
          <ChevronArrowRight
            gradientOpacity={0}
            onPress={slideNext}
            color={arrowColor}
            scale={arrowScale ?? (isLarge ? 2 : 1.5)}
          />
        </ArrowArea>
      )}
    </Container>
  )
}
